export enum ToastPosition {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
  TopLeft = "top-left",
  TopRight = "top-right",
  BottomLeft = "bottom-left",
  BottomRight = "bottom-right",
}

export enum ToastVariant {
  Success = "success",
  Warning = "warning",
  Danger = "danger",
}

export type ToastPositionValue = `${ToastPosition}`;
export type ToastVariantValue = `${ToastVariant}`;
